import React from "react";

export const PetImage = ({
  imageSrc,
  altValue,
}: {
  imageSrc: string;
  altValue: string;
}) => {
  return (
    <div className="pet-image">
      <img src={imageSrc} alt={altValue} data-testid="petImage" />
    </div>
  );
};
